import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import Categories from "@/pages/Categories";
import ProviderProfile from "@/pages/ProviderProfile";
import BookingFlow from "@/pages/BookingFlow";
import BookingConfirmed from "@/pages/BookingConfirmed";
import MyBookings from "@/pages/MyBookings";
import BookingDetail from "@/pages/BookingDetail";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import ListBusiness from "@/pages/ListBusiness";
import ProviderDashboard from "@/pages/ProviderDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

function Layout() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}

const guard = (el, roles) => <ProtectedRoute roles={roles}>{el}</ProtectedRoute>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Search />} />
              <Route path="/providers" element={<Search />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/provider/:id" element={<ProviderProfile />} />
              <Route path="/book/:providerId" element={guard(<BookingFlow />)} />
              <Route path="/bookings" element={guard(<MyBookings />)} />
              <Route path="/bookings/:id" element={guard(<BookingDetail />)} />
              <Route path="/bookings/:id/confirmed" element={guard(<BookingConfirmed />)} />
              <Route path="/list-your-business" element={<ListBusiness />} />
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/provider-dashboard" element={guard(<ProviderDashboard />, ["provider"])} />
              <Route path="/admin" element={guard(<AdminDashboard />, ["admin"])} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
